/** The bearer token. Kept in memory and mirrored to sessionStorage so a reload keeps you signed
 * in but closing the tab does not. Never localStorage: a token should not outlive the visit. */
const KEY = "vs-token";
let token: string | null = null;

try {
  token = sessionStorage.getItem(KEY);
} catch {
  /* storage blocked: memory only */
}

export const getToken = () => token;

export function setToken(next: string | null) {
  token = next;
  try {
    if (next) sessionStorage.setItem(KEY, next);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* memory only */
  }
}
